export const flightRequestsHeaderElements = [
  { label: "Titular cuenta", value: "titularCuenta" },
  { label: "Establecimiento y Hectáreas", value: "procedencia" },
  { label: "Tipo de servicio", value: "tipoServicio" },
  { label: "Estado", value: "displayEstado" },
];
